import { FormikErrors } from 'formik'

const validateAddress = address => {
  if (!address) {
    return 'Indicanos una dirección dónde buscar cuidadores'
  }
  return undefined
}

export const locationValidator = (formValues, address) => {
  let error
  let errors: FormikErrors<any> = {}

  error = validateAddress(address)
  if (error) errors.address = error

  return errors
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/LocationStep/LocationStep.validator.ts